import React, { memo } from "react";
import { DigioAuthenticationComponent } from "./DigioAuthenticationComponent";
const DigioCoBorrowerIntegration = ({ digioDocumentId, digioToken, identifier, action, triggerAction, options, 
//@ts-ignore
cancelAction }) => {
    const onSuccessReceived = async (response) => {
        if (response.type !== undefined || response.error !== undefined) {
            action && triggerAction && await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    type: response.type === undefined ? "undefined" : response.type,
                    error: response.error === undefined ? "undefined" : response.error
                },
            });
        }
    };
    const onCancelCallback = async (response) => {
        cancelAction && triggerAction && await triggerAction({
            ...cancelAction,
        });
    };
    return (React.createElement(DigioAuthenticationComponent, { onSuccess: onSuccessReceived, onCancel: onCancelCallback, options: options, digioDocumentId: digioDocumentId, digioToken: digioToken, identifier: identifier }));
};
export default memo(DigioCoBorrowerIntegration);
export { DigioCoBorrowerIntegration };
